import React from 'react'
import ReactDOM from 'react-dom'
import {
  BrowserRouter as Router,
  Route,
  Switch,
  Redirect,
} from 'react-router-dom'

import './style.css'
import TermsOfService from './views/terms-of-service'
import Contact from './views/contact'
import PrivacyPolicy from './views/privacy-policy'
import Features from './views/features'
import Pricing1 from './views/pricing1'
import NotFound from './views/not-found'

const App = () => {
  return (
    <Router>
      <Switch>
        <Route component={TermsOfService} exact path="/terms-of-service" />
        <Route component={Contact} exact path="/contact" />
        <Route component={PrivacyPolicy} exact path="/privacy" />
        <Route component={Features} exact path="/" />
        <Route component={Pricing1} exact path="/pricing" />
        <Route component={NotFound} path="**" />
        <Redirect to="**" />
      </Switch>
    </Router>
  )
}

ReactDOM.render(<App />, document.getElementById('app'))
